import './styles/_pdp-section.scss';
import Swiper from 'swiper-latest/bundle';
import {isScriptFullyLoaded, markScriptFullyLoaded, onDocumentReady,} from '../utils/dom';
import {removeQueryParams, setQueryParams} from '../utils/url';

import {onAddToCart as onAddToCartService} from '../services/cart';
import {getProductVariantData, getVariantQuantity, isFinalSale, isUnreturnable, retrieveSku,} from '../utils/product';
import OverflowScroller from '../lib/OverflowScroller';
import {replaceWords} from '../services/filter-value';
import {PRODUCT_CHANGED_EVENT} from '../common/pdp-events';

const DESKTOP_MEDIA = window.matchMedia('(min-width: 1009px)');

const state = {
  elements: {},
  product: window.product,
  optionGroups: [],
  selectedVariant: null,
  klaviyoAccountID: 'QEgd3D',
  isPDP: window.location.pathname.includes('/products/'),
};

const cacheState = () => {
  state.elements = {
    pdpOptionWrappers: document.querySelectorAll('.pdp__option--wrapper'),
    stickyElement: document.querySelector('[data-sticky-element]'),
    quantity: document.querySelector('#quantity'),
    contentWrapper: document.querySelector('.pdp__options--card'),
    sliders: document.querySelector('.pdp-grid--container'),
    quantitySelector: document.querySelector('.quantity__selector'),
    minusBtn: document.querySelector('.quantity__selector--minus'),
    plusBtn: document.querySelector('.quantity__selector--plus'),
    addToCart: document.querySelector('#add-to-cart'),
    colorOptions: document.querySelectorAll('.pdp__options--item'),
    productPrice: document.querySelector('.pdp__content--price-inner'),
    compareAtprice: document.querySelector('.pdp__content--compare-price'),
    productTitle: document.querySelector('.pdp__content--title'),
    productSoldOutLabel: document.querySelector('.pdp__options--sold-out'),
    pdpQuantityWrapper: document.querySelector('.pdp__quantity--box'),
    notifyButton: document.querySelector('.notify__button'),
    notifyBackdrop: document.querySelector('.notify__backdrop'),
    notifyBtn: document.querySelector('.Product__form-cta--sold_out'),
    notifyForm: document.querySelector('.notify__form'),
    notifyEmailInput: document.querySelector('.notify__form input'),
    notifyBtnCta: document.querySelector('.notify__form button'),
    notifyInvalidEmail: document.querySelector('.invalid-email-message'),
    sliderImage: document.querySelectorAll('.slider-img-item'),
    sliderVideo: document.querySelector('.slider-video-item'),
    sliderGrid: document.querySelector('.pdp-grid--slider'),
    sliderZoom: document.querySelectorAll('.pdp__zoom--slider'),
    optionWrapper: document.querySelectorAll('.pdp__options--wrapper'),
    optionColors: document.querySelectorAll('.pdp__options--color'),
    optionColorWrapper: document.querySelector('.pdp__options--mobile-header'),
    colorsContainer: document.querySelector('.pdp__options--bottom'),
    optionBottomBackdrop: document.querySelector('.pdp__options--backdrop'),
    optionColorIcon: document.querySelector('.pdp__options--color-icon'),
    optionColorClose: document.querySelector('.pdp__options--color-close'),
    swiperButtonNext: document.querySelector('.swiper-button-next'),
    swiperButtonPrev: document.querySelector('.swiper-button-prev'),
    accordionProductDescription: document.querySelector(
      '.accordion-product-description'
    ),
    accordionProductMetafield: document.querySelector(
      '.accordion-product-metafield'
    ),
    accordionProductVariant: document.querySelector(
      '.accordion-product-variant'
    ),
    body: document.querySelector('body'),
    header: document.querySelector('.section-header'),
    pdpGrid: document.querySelector('.pdp-grid'),
    klarnaWrappers: document.querySelectorAll('.klarna-pay--wrapper'),
    pdpOptionsCard: document.querySelectorAll('.pdp__options--card'),
    fitGuide: document.querySelector('.fitGuideModal'),
    fitModal: document.querySelector('.modal-bg'),
    fitCloseButton: document.querySelector('.modal-bg__close-btn'),
    onlineExclusiveLabel: document.querySelector('.pdp__content--label'),
    onlineExclusive: document.querySelector('.pdp__label--span'),
    buttonErrorMessage: document.querySelector('.pdp__error--message'),
    formContainer: document.querySelector('.pdp-info--container'),
  };

  state.optionGroups = Array.from(state.elements.pdpOptionWrappers).map(
    (wrapper) => ({
      wrapper,
      fieldSet: wrapper.querySelector('.pdp__option--fieldset'),
      options: wrapper.querySelectorAll('input'),
      selectedTitle: wrapper.querySelector('.pdp__option--selected'),
      errorMessage: wrapper.querySelector('.pdp__option--left'),
    })
  );
};

const sizesMap = new Map([
  ['4XS', '4X SMALL'],
  ['XXXXS', 'XXXX SMALL'],
  ['3XS', '3X SMALL'],
  ['XXXS', 'XXX SMALL'],
  ['2XS', 'XX SMALL'],
  ['XXS', '2X SMALL'],
  ['XS', 'X SMALL'],
  ['S', 'SMALL'],
  ['M', 'MEDIUM'],
  ['L', 'LARGE'],
  ['XL', 'X LARGE'],
  ['2XL', 'XX LARGE'],
  ['XXL', '2X LARGE'],
  ['3XL', '3X LARGE'],
  ['XXXL', 'XXX LARGE'],
  ['4XL', '4X LARGE'],
  ['XXXXL', 'XXXX LARGE'],
]);

const handleQuantityClick = (e) => {
  const actionType = e.target.closest('button').dataset.type;
  if (!actionType) return;

  const quantityInput = state.elements.quantity;
  const currentValue = +quantityInput.value;
  const maxValue = +quantityInput.max;
  const minValue = +quantityInput.min;

  if (actionType === 'plus' && currentValue < maxValue) {
    quantityInput.value = currentValue + 1;
  }

  if (actionType === 'minus' && currentValue > minValue) {
    quantityInput.value = currentValue - 1;
  }
};

const handleQuantityInput = (e) => {
  const input = e.target;
  const newValue = parseInt(input.value, 10);
  if (newValue > input.max) {
    input.value = input.max;
  } else if (newValue < input.min || isNaN(newValue)) {
    input.value = input.min;
  }
}

const initSwipers = () => {
  state.swiper = new Swiper(state.elements.sliders, {
    preloadImages: false,
    loop: true,
    slidesPerView: 1,
    lazy: true,
    speed: 500,
    initialSlide: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous image',
      nextSlideMessage: 'Next image',
      containerMessage: 'Product image gallery',
    },
  });
};

const getSelectedColor = () => {
  if (state.product.options[0] === 'Color') {
    return state.product.variants[0]?.option1;
  }
};

const reverseSizesMap = new Map();
sizesMap.forEach((value, key) => {
  if (!reverseSizesMap.has(value)) {
    reverseSizesMap.set(value, key);
  }
});

const formatPrice = (number) => {
  if (isNaN(number)) return number
  const currentPrice = +number;
  const priceWithoutDecimal = +currentPrice.toFixed(0)
  const formatedPrice = priceWithoutDecimal.toLocaleString()
  return `${localizationCurrencyCode} ${formatedPrice}`;
};

const calculateSelectedVariant = () => {
  const selectedColor = getSelectedColor();
  const selectedOptions = state.optionGroups.reduce(
    (acc, curr) => {
      const sizeValue = curr.selectedTitle.textContent.trim();
      if (reverseSizesMap.has(sizeValue)) {
        return [...acc, reverseSizesMap.get(sizeValue)];
      }
      return [...acc, sizeValue];
    },
    selectedColor ? [selectedColor] : []
  );

  const matchedVariant = state.product.variants.find((variant) =>
    selectedOptions.every((option, index) => variant.options[index] === option)
  );

  state.selectedVariant = matchedVariant;

  return matchedVariant;
};


const updateSelectedVariantUrl = () => {
  if (state.selectedVariant) {
    setQueryParams({ variant: state.selectedVariant.id });
  } else {
    removeQueryParams(['variant']);
  }
};

const showNotify = () => {
  const { selectedVariant } = state;

  if (!selectedVariant) return;

  state.elements.pdpQuantityWrapper.classList.toggle(
    'out-of-stock',
    !selectedVariant.available
  );
};

function onOptionChange(e) {
  state.elements.buttonErrorMessage.textContent = '';
  const sizeKey = e.target.value;
  if (sizesMap.has(sizeKey)) {
    this.selectedTitle.textContent = sizesMap.get(sizeKey);
  } else {
    this.selectedTitle.textContent = e.target.value;
  }
  this.errorMessage.classList.remove('error');

  updateProductPrice(calculateSelectedVariant());
  updateSelectedVariantUrl();
  showNotify();
}

const getFirstUnselectedOption = () =>
  state.optionGroups.find((group) => !group.selectedTitle.textContent.trim());

const validateForm = () => {
  const firstUnselectedOption = getFirstUnselectedOption();

  if (!firstUnselectedOption) return false;

  firstUnselectedOption.errorMessage.classList.add('error');

  // Move focus to the unselected group so screen readers announce the group
  // name and the now-visible "Choose your …" error message.
  firstUnselectedOption.options?.[0]?.focus();

  return firstUnselectedOption;
};

const addToCart = async (productId, quantity) => {
  const formData = {
    items: [{ id: productId, quantity }],
  };

  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });

  return response.json();
};

const addToCartFunction = async (e) => {
  e.preventDefault();

  state.elements.buttonErrorMessage.textContent = '';

  if (validateForm()) return;

  const matchedVariant = calculateSelectedVariant();

  if (!matchedVariant) return;

  const productId = matchedVariant.id;
  const quantity = +state.elements.quantity.value;
  const originalAddToCartText = state.elements.addToCart.textContent;
  state.elements.addToCart.textContent = 'Adding to Cart...';

  // const items = [{ id: productId, quantity }];

  const { price, compare_at_price, sku, id } =
    await getProductVariantData(matchedVariant);
  const items = [
    {
      id,
      quantity,
      properties: {
        _OriginalPrice: `$${(+price).toFixed(2)}`,
        _ProductSku: retrieveSku(sku),
        _CompareAtPrice:
          compare_at_price && `$${(+compare_at_price).toFixed(2)}`,
        _productTitle: replaceWords(state.product.title),
      },
    },
  ];

  if (isFinalSale(price, compare_at_price) || isUnreturnable(state.product)) {
    items[0].properties._finalSale = 'Final Sale';
    items[0].properties._LPROP = 'Final Sale';
  }

  try {
    state.elements.quantity.value = 1;
    const response = await onAddToCartService(items, matchedVariant);
    if (response.message) {
      state.elements.buttonErrorMessage.textContent = response.message;
    }
  } catch (error) {
    console.log('Error Message', error);
  } finally {
    setTimeout(() => {
      state.elements.addToCart.textContent = originalAddToCartText;
    }, 100);
  }
};

const updateProductHandle = (newHandle) => {
  state.selectedVariant = null;
  updateSelectedVariantUrl();

  const newPathName = `${window.location.origin}/products/${newHandle}${window.location.search}`;
  window.history.replaceState({}, '', newPathName);
};

const updateProductSelectionUI = (productHandle) => {
  const { product } = state;
  state.elements.productTitle.textContent = replaceWords(product.title);
  state.elements.optionColors.forEach(
    (color) => (color.textContent = product.variants[0].option1)
  );

  state.optionGroups.forEach((group) => {
    group.selectedTitle.textContent = '';
  });

  state.elements.colorOptions.forEach((item) => {
    const isSelected = item.dataset.handle === productHandle;
    item.classList.toggle('active', isSelected);
    // `.active` is a border only, so name the selected colorway for AT too.
    if (isSelected) item.setAttribute('aria-current', 'true');
    else item.removeAttribute('aria-current');
  });
};

const getImageMarkup = (image, index = 0, total = 0) => `
        <figure
            itemprop="associatedMedia"
            itemscope
            itemtype="http://schema.org/ImageObject"
            class="slider-item swiper-slide placeholder-loader__content"
        >
        <a
            href="${image}&width=2500"
            data-pswp-width="2500"
            data-pswp-height="2500"
            itemprop="contentUrl"
            class="pdp-slider__image"
            aria-label="Zoom image ${index + 1} of ${total}"
        >
            <img class="slider-img-item" loading="lazy" itemprop="thumbnail" src="${image}&width=2000" width="100%" height="100%" alt="${state.product.title}">
        </a>
        </figure>
    `;

const getVideoMarkup = (video) => `
        <div class="slider-item item-video swiper-slide placeholder-loader__content">
            <video class="slider-video-item" autoplay muted loop playsinline style="width: 100%; height: 100%;" type="video/mp4" src="${video}">
            </video>
        </div>
    `;

const updateProductGallery = (product) => {
  const markup = product.images.reduce((acc, curr, index) => {
    const imageMarkup = getImageMarkup(curr, index, product.images.length);
    acc += imageMarkup;

    if (index == 0 && product.video) {
      const videoMarkup = getVideoMarkup(product.video);
      acc += videoMarkup;
    }

    return acc;
  }, '');

  state.elements.sliderGrid.innerHTML = markup;
};

const getOptionValues = (optionIndex) => {
  const values = state.product.variants.map(
    (variant) => variant.options[optionIndex]
  );
  return [...new Set(values)];
};

const getOptionsValuesMarkup = (option, optionIndex) => {
  const options = getOptionValues(optionIndex);
  return options
    .map((value) => {
      let isOutOfStock = true;
      state.product.variants.forEach((variant) => {
        if (variant.options[optionIndex] == value && variant.available) {
          isOutOfStock = false;
        }
      });
      if (option == 'Color') return null;
      return `
            <div class="pdp__option--variants">
                <input
                    class="pdp__option--input"
                    type="radio"
                    required
                    name="${option}"
                    value="${value}"
                    id="${option.toLowerCase().replace(/\s+/g, '-')}-${value.toLowerCase().replace(/\s+/g, '-')}"/>
                <label class="pdp__option--variants-label ${isOutOfStock ? 'pdp__option--disabled' : null}" for="${option.toLowerCase().replace(/\s+/g, '-')}-${value.toLowerCase().replace(/\s+/g, '-')}">${value}</label> 
                ${isOutOfStock ? '<span class="pdp__option--sold-out">Sold Out</span>' : ''}
            </div>
        `;
    })
    .filter(Boolean)
    .join('');
};

const updateProductPrice = (variant) => {
  if (variant) {
    state.elements.productPrice.textContent = formatPrice(variant.price / 100);
    state.elements.compareAtprice.textContent = variant.compare_at_price ? formatPrice(variant.compare_at_price / 100) : '';
  }
}

const updateOptions = () => {
  const markup = state.product.options
    .map(getOptionsValuesMarkup)
    .filter(Boolean);

  state.optionGroups.forEach((group, index) => {
    group.fieldSet.innerHTML = markup[index];
  });
};

const updateAccordionInfo = () => {
  const { product } = state;
  state.elements.accordionProductVariant.textContent = `${product.variants[0].options[0]}`;
};

const replaceProductDescriptionWord = () => {
  const descriptionText = state.elements.accordionProductDescription.innerHTML;
  state.elements.accordionProductDescription.innerHTML = replaceWords(descriptionText);
};

const updateProductAvailability = (force) => {
  state.elements?.productSoldOutLabel?.classList.toggle('out-of-stock', !force);
  state.elements.pdpQuantityWrapper.classList.toggle('out-of-stock', !force);
};

const updateOnlineExclusive = (e) => {
  const exclusiveLabel =
    e.target.closest('[data-exclusive]')?.dataset?.exclusive;
  if(!exclusiveLabel) return; 
  state.elements.onlineExclusiveLabel.classList.toggle(
    'active',
    exclusiveLabel
  );
  state.elements.onlineExclusive.textContent = exclusiveLabel;
};

const onColorChange = (e) => {
  state.elements.buttonErrorMessage.textContent = '';
  state.elements.quantity.value = 1;
  const productHandle = e.target.closest('[data-handle]')?.dataset?.handle;
  const product = window.relatedProducts.find(
    (product) => product.handle === productHandle
  );
  if (!product) return;

  state.product = product;
  const isAvailable = product.variants.some((variant) => variant.available);
  updateOnlineExclusive(e);
  updateProductSelectionUI(productHandle);
  updateProductGallery(product);
  updateProductAvailability(isAvailable);
  updateAccordionInfo();
  updateOptions();
  if (state.isPDP) {
    updateProductHandle(productHandle);
    // Sections rendered outside the PDP form (recommended / complementary
    // products) are bound to the product that was loaded with the page. The
    // colourway swap never reloads, so tell them which product is on screen
    // now. Quick view is excluded on purpose: it must not repoint the PDP's
    // own sections at the product being previewed.
    document.dispatchEvent(
      new CustomEvent(PRODUCT_CHANGED_EVENT, {
        detail: { handle: product.handle, id: product.id },
      })
    );
  }
};

const onDesktopMediaChange = () => {
  if (DESKTOP_MEDIA.matches) {
    // The color sheet is mobile-only. Leaving it "open" across the breakpoint
    // would keep the body scroll-locked and the dialog role on what is now an
    // ordinary inline swatch row.
    removeColor();
    state.swiper?.destroy();
    return;
  }
  initSwipers();
  state.swiper.update();
};

let colorSheetTrapHandler = null;

// Only the trigger that can actually open the sheet is a <button>; the
// single-colorway variant is plain text and must not claim expanded state.
const setColorSheetExpanded = (isExpanded) => {
  const trigger = state.elements.optionColorWrapper;
  if (!trigger?.hasAttribute('aria-controls')) return;
  trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
};

const showColor = (optionsCount) => {
  if(optionsCount < 2) return;
  const sheet = state.elements.colorsContainer;
  state.elements.body.classList.add('active');
  setColorSheetExpanded(true);
  if (!sheet) return;

  // Below the breakpoint the swatch row becomes a modal bottom sheet over a
  // backdrop, so it needs dialog semantics while it is open. Desktop keeps
  // role="group" — showColor only ever runs from the mobile trigger.
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  colorSheetTrapHandler = (e) => trapFocus(sheet, e);
  sheet.addEventListener('keydown', colorSheetTrapHandler);

  // Focus a leaf control, not the dialog container: focusing the container
  // makes VoiceOver read the whole sheet aloud. The selected swatch is the
  // most useful landing spot.
  const landing =
    sheet.querySelector('.pdp__options--item.active') ||
    state.elements.optionColorClose;
  landing?.focus();
};

const removeColor = () => {
  const sheet = state.elements.colorsContainer;
  const wasOpen = state.elements.body.classList.contains('active');
  state.elements.body.classList.remove('active');
  setColorSheetExpanded(false);
  // Desktop clicks land in the same swatch container, so only unwind the
  // dialog (and move focus) when the sheet was actually open.
  if (!sheet || !wasOpen) return;

  sheet.setAttribute('role', 'group');
  sheet.removeAttribute('aria-modal');
  if (colorSheetTrapHandler) {
    sheet.removeEventListener('keydown', colorSheetTrapHandler);
    colorSheetTrapHandler = null;
  }
  state.elements.optionColorWrapper?.focus?.();
};

const showNotifyModal = () => {
  state.elements.body.classList.toggle('notify-active');
};

const onKlarnaLoad = (mutationList, observer) => {
  const desktopKlarna = document.querySelector('.klarna-pay--wrapper-desktop klarna-placement')?.shadowRoot;
  const desktopStyle = document.createElement('style');
  desktopStyle.innerHTML = `
  .badge svg {
    max-width: 55px
  }
  .container { 
    border:none!important;
  };
    `;

  requestAnimationFrame(() => {
    desktopKlarna?.appendChild(desktopStyle);
  });

  mutationList.forEach((list) => {
    const shadowRoot =
      list.target.querySelector('klarna-placement')?.shadowRoot;
    const container = shadowRoot?.querySelector('.container');
    if (!shadowRoot) return;
    const style = document.createElement('style');
    style.innerHTML = `
          .container { 
            border:none!important;
            padding:0!important; 
          };
      
          .container > p {
            font-family: "GalanoGrotesqueRegular", sans-serif!important;
            text-align: start!important;
          };
      
          .container .logo {
            font-family: inherit!important;
            font-weight: 400!important;
            letter-spacing: inherit!important;
            font-size: inherit!important;
          };
      
          .text-wrapper {
            font-size: 1.2rem!important;
            line-height: 1.6!important;
          };
      
          .text-wrapper button {
            font-size: 1.2rem!important;
            line-height: 1.6!important;
          }
          .badge {
            max-width: 55px;
          };
        `;

    shadowRoot.appendChild(style);

    if (!container) return;
    observer.disconnect();
  });
};

const FOCUSABLE_SELECTOR =
  'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

// A control still occupies layout when it is `visibility: hidden`, so a box-size
// check alone reports it as focusable while the browser refuses to focus it.
// Kiwi's size-guide close control is exactly that during the open animation, and
// counting it left the trap thinking the dialog had one focusable item: every
// Tab was cancelled and redirected onto a control that could not take focus, so
// focus never moved at all.
const isFocusableNow = (el) =>
  (el.offsetWidth || el.offsetHeight || el.getClientRects().length) &&
  getComputedStyle(el).visibility !== 'hidden';

// Keep Tab / Shift+Tab within an open dialog (focus trap).
const trapFocus = (container, e) => {
  if (e.key !== 'Tab') return;
  const items = [...container.querySelectorAll(FOCUSABLE_SELECTOR)].filter(
    isFocusableNow
  );
  // Nothing focusable inside — let Tab through rather than cancelling it, or the
  // dialog becomes a dead end with no way forward and no way out.
  if (!items.length) return;
  const first = items[0];
  const last = items[items.length - 1];
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
};

let fitModalReturnFocus = null;
let fitTrapHandler = null;
const showFitModal = () => {
  const modal = state.elements?.fitModal;
  if (!modal) return;
  const isOpen = modal.classList.toggle('active');
  if (isOpen) {
    fitModalReturnFocus = document.activeElement;
    const content = modal.querySelector('.modal-bg__content') || modal;
    fitTrapHandler = (e) => trapFocus(content, e);
    modal.addEventListener('keydown', fitTrapHandler);
    // Focus the Close button (a leaf control), NOT the dialog container.
    // Focusing the role="dialog" container makes VoiceOver read the whole dialog
    // subtree aloud on open; focusing a control keeps the announcement to the
    // dialog boundary plus the button. VoiceOver still says "Fit guide, dialog"
    // as focus crosses into the modal, then "Close, button".
    (state.elements?.fitCloseButton || content).focus();
  } else {
    if (fitTrapHandler) {
      modal.removeEventListener('keydown', fitTrapHandler);
      fitTrapHandler = null;
    }
    fitModalReturnFocus?.focus?.();
    fitModalReturnFocus = null;
  }
};

// The size-guide trigger (injected by the Kiwi Sizing app as
// `span.ks-chart-modal-link`) and the theme's fit-guide trigger
// (`span.fitGuideModal`) render as non-focusable spans. Promote them to
// real, keyboard-operable buttons. Idempotent + re-run on DOM changes since
// Kiwi injects/re-renders its trigger asynchronously.
const enhanceGuideTriggers = () => {
  document
    .querySelectorAll('.ks-chart-modal-link, .fitGuideModal')
    .forEach((el) => {
      if (el.dataset.a11yEnhanced) return;
      el.dataset.a11yEnhanced = 'true';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-haspopup', 'dialog');
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          el.click();
        }
      });
    });
};

// Kiwi renders the size chart as a real <table>, but every cell is a <td> —
// including the ones it visually styles as headers (`.ks-table-header-cell`).
// With no <th> and no header roles, the table has no header semantics at all,
// so a screen reader on the cell "39.5" announces "39.5" and nothing else: no
// indication it is the HIP WIDTH for size 31. The chart is readable but
// meaningless without sight.
//
// Give the cells Kiwi already marks as headers the matching roles. `role` is
// what the accessibility tree reads, so this works on a <td> without having to
// replace nodes Kiwi owns and re-renders. VoiceOver then announces the row and
// column header along with each value.
//
// Layout: row 0 is the column-header row; the first cell of every later row is
// that row's header (WIAST, HIP WIDTH, …).
const enhanceKiwiTableHeaders = () => {
  document.querySelectorAll('.kiwi-sizing-modal table').forEach((table) => {
    const rows = table.querySelectorAll('tr');
    rows.forEach((row, rowIndex) => {
      Array.from(row.children).forEach((cell, cellIndex) => {
        if (!cell.classList.contains('ks-table-header-cell')) return;
        if (cell.dataset.a11yHeader) return;

        // Row 0 is the column-header row. Below it, only the leading cell is a
        // header — a mid-row cell carrying the header *class* is styling, not
        // structure, and marking it would associate the wrong label with the
        // values beside it.
        const isColumnHeader = rowIndex === 0;
        if (!isColumnHeader && cellIndex !== 0) return;

        cell.dataset.a11yHeader = 'true';
        cell.setAttribute('role', isColumnHeader ? 'columnheader' : 'rowheader');
        cell.setAttribute('scope', isColumnHeader ? 'col' : 'row');
      });
    });
  });
};

// Kiwi's size-guide modal exposes role="dialog"/aria-modal but does NOT move
// focus into itself on open (focus stays on <body>), and its close control is a
// non-focusable <span>. Move focus into the dialog on open so VoiceOver enters
// it, make the close keyboard-operable, and restore focus to the trigger on close.
// Kiwi's close control is a non-focusable <span>. Promote it to a real keyboard
// button. Called both when the modal opens and from the focus-landing retry
// loop, because Kiwi builds the control asynchronously — focus cannot land on it
// until it is focusable. Idempotency is keyed on tabindex rather than a data
// flag so a control Kiwi has rebuilt gets enhanced again, while one it reused
// does not collect a second keydown listener.
const promoteKiwiClose = (dialog) => {
  const close = dialog.querySelector('.ks-modal-close');
  if (!close) return null;
  // Deliberately no aria-describedby, on the dialog or on Close.
  //
  // A description on the close control made VoiceOver announce a
  // name-plus-description pass first — "Close, press Control Option and the
  // Right Arrow…" with no role — so the real "Close, button" (and with it
  // working VO+Right Arrow navigation) only arrived after a *second* interact.
  // The instructions cost an extra level to reach the content they described.
  //
  // Nothing is lost by dropping them: the chart is a real <table>, which
  // VoiceOver already announces and navigates natively.
  close.removeAttribute('aria-describedby');
  if (close.getAttribute('tabindex') === '0') return close;
  close.setAttribute('role', 'button');
  close.setAttribute('tabindex', '0');
  if (!close.getAttribute('aria-label')) {
    close.setAttribute('aria-label', 'Close size guide');
  }
  close.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      close.click();
    }
  });
  return close;
};

// Real modality for the size guide, replacing `aria-modal="true"`.
//
// Kiwi's dialog is a direct child of <body> next to ~70 siblings, none of which
// are hidden from assistive tech — so `aria-modal` is the only thing scoping the
// screen reader, and it does that badly: VoiceOver confines the cursor to the
// dialog but will not step onto the *non-focusable* content inside it, so from
// the Close button it re-announces "Size guide, dialog" instead of moving to the
// chart. That is the "cannot move to the content" dead end.
//
// `inert` scopes the same thing structurally — inert subtrees leave both the
// accessibility tree and the tab order — and leaves the dialog's own contents
// navigable, so VoiceOver walks Close → chart normally.
let kiwiInertedNodes = [];
const setKiwiBackgroundInert = (dialog, isInert) => {
  if (isInert) {
    kiwiInertedNodes = [...document.body.children].filter(
      (el) => el !== dialog && !el.contains(dialog) && !el.hasAttribute('inert')
    );
    kiwiInertedNodes.forEach((el) => el.setAttribute('inert', ''));
    return;
  }
  kiwiInertedNodes.forEach((el) => el.removeAttribute('inert'));
  kiwiInertedNodes = [];
};

let kiwiModalOpen = false;
let kiwiReturnFocus = null;
let kiwiTrapHandler = null;
let kiwiFocusGuard = null;
const syncKiwiModalFocus = () => {
  const isOpen = !!document.querySelector('.kiwi-sizing-modal-visible');
  if (isOpen && !kiwiModalOpen) {
    const dialog = document.querySelector('.kiwi-sizing-modal');
    if (!dialog) return; // not built yet — retry on the next mutation
    kiwiModalOpen = true;
    kiwiReturnFocus = document.querySelector('.ks-chart-modal-link');
    // Keep the *named* outer dialog focusable (tabindex="-1") so we can land focus
    // on it — VoiceOver then announces "Size guide, dialog". But strip tabindex from
    // the *unnamed* inner wrapper: a focused unnamed container is what made VoiceOver
    // read the whole chart aloud, so vanilla-modal must not be able to focus it.
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    dialog.querySelector('.kiwi-sizing-modal-inner')?.removeAttribute('tabindex');
    // Kiwi's modal container has no accessible name, so focusing it made
    // VoiceOver compute the name from its contents — reading the whole chart
    // aloud. Naming the dialog makes it announce as "Size guide, dialog" instead.
    if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
      dialog.setAttribute('aria-label', 'Size guide');
    }
    dialog.removeAttribute('aria-describedby');
    // Drop Kiwi's aria-modal and scope the page with `inert` instead — see
    // setKiwiBackgroundInert. Leaving both on would reinstate the same
    // VoiceOver dead end that inerting is here to fix.
    dialog.removeAttribute('aria-modal');
    setKiwiBackgroundInert(dialog, true);
    // The hint node was appended to <body>, so it also surfaced as a loose
    // string at the end of the page's accessibility tree. Clear any left from
    // an earlier run in this session.
    document.getElementById('kiwi-size-guide-hint')?.remove();
    promoteKiwiClose(dialog);
    kiwiTrapHandler = (e) => trapFocus(dialog, e);
    dialog.addEventListener('keydown', kiwiTrapHandler);
    // Land focus on the *named* outer dialog so the reading order is
    // dialog → Close → chart: VoiceOver announces "Size guide, dialog" on open,
    // then the next step lands on Close, then the content.
    //
    // This only works because the dialog itself is not in the tab cycle
    // (tabindex="-1"), so Tab from here falls through to the first real control
    // inside — the Close button — instead of being caught by the focus trap.
    // Landing directly on Close would make it both the first and the last
    // focusable, and every Tab would loop back onto itself.
    //
    // Promote the close control on every retry: Kiwi builds it asynchronously,
    // and it has to be focusable before the step off the dialog can reach it.
    //
    // The modal animates open (vanilla-modal toggles `kiwi-sizing-modal-visible`
    // on <html>) and may focus its inner wrapper first, so retry across frames
    // until focus actually lands on the dialog.
    const focusTarget = dialog;
    let kiwiFocusTries = 0;
    const landKiwiFocus = () => {
      if (!document.querySelector('.kiwi-sizing-modal-visible')) return; // closed — abort
      promoteKiwiClose(dialog);
      focusTarget.focus();
      if (document.activeElement === focusTarget) return; // landed
      if (kiwiFocusTries++ < 40) requestAnimationFrame(landKiwiFocus);
    };
    landKiwiFocus();
    // Belt-and-suspenders: if vanilla-modal focuses the unnamed inner wrapper at any
    // point during/after the open animation, bounce focus back to the close control
    // so VoiceOver never ends up reading the whole chart. Removed on close.
    kiwiFocusGuard = (e) => {
      if (!document.querySelector('.kiwi-sizing-modal-visible')) return;
      const t = e.target;
      if (t.classList && t.classList.contains('kiwi-sizing-modal-inner')) {
        (dialog.querySelector('.ks-modal-close') || dialog).focus();
      }
    };
    document.addEventListener('focusin', kiwiFocusGuard);
  } else if (!isOpen && kiwiModalOpen) {
    kiwiModalOpen = false;
    const dialog = document.querySelector('.kiwi-sizing-modal');
    if (dialog && kiwiTrapHandler) {
      dialog.removeEventListener('keydown', kiwiTrapHandler);
    }
    kiwiTrapHandler = null;
    if (kiwiFocusGuard) {
      document.removeEventListener('focusin', kiwiFocusGuard);
      kiwiFocusGuard = null;
    }
    // Un-inert BEFORE restoring focus: the trigger lives in one of the inerted
    // subtrees, and an inert element cannot take focus.
    setKiwiBackgroundInert(null, false);
    kiwiReturnFocus?.focus?.();
    kiwiReturnFocus = null;
  }
};

const onFetchNotify = (e) => {
  e.preventDefault();
  e.stopPropagation();
  const matchedVariant = calculateSelectedVariant();
  const isValidEmail = state.elements.notifyEmailInput.checkValidity();
  if (!isValidEmail) {
    onInvalidEmail();
    return;
  }
  const email = state.elements.notifyEmailInput.value;
  state.elements.notifyBtnCta.innerHTML = 'Processing';

  fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${state.klaviyoAccountID}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      revision: '2026-04-15',
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${matchedVariant.id}`,
            },
          },
        },
      },
    }),
  })
    .then((res) => {
      if (res.ok) {
        state.elements.notifyBtnCta.innerHTML = 'Added to list';
        state.elements.notifyEmailInput.value = '';
        setTimeout(() => {
          state.elements.notifyBtnCta.innerHTML = 'Notify me';
          showNotifyModal();
        }, 3000);
      } else {
        state.elements.notifyBtnCta.innerHTML = 'Error. Try again';
      }
    })
    .catch(() => {
      state.elements.notifyBtnCta.innerHTML = 'Error. Try again';
    });
};

const onInvalidEmail = (e) => {
  e?.preventDefault();
  state.elements.notifyInvalidEmail.classList.add('invalid');
};

const onEmailChange = (e) =>
  state.elements.notifyInvalidEmail.classList.remove('invalid');

const attachEventListeners = () => {
  state.elements.notifyBtnCta.addEventListener('click', onFetchNotify);
  state.elements.notifyInvalidEmail.addEventListener('invalid', onInvalidEmail);
  state.elements.notifyEmailInput.addEventListener('input', onEmailChange);
  state.elements.quantitySelector.addEventListener(
    'click',
    handleQuantityClick
  );
  state.elements.quantity.addEventListener('input', handleQuantityInput);
  state.elements?.fitCloseButton?.addEventListener('click', showFitModal);
  state.elements?.fitGuide?.addEventListener('click', showFitModal);
  // Make the size/fit guide triggers keyboard-operable and manage focus for the
  // Kiwi size-guide modal. Re-run on DOM changes: Kiwi injects its trigger
  // asynchronously (variant/color change) and toggles the modal open/closed via
  // a class, so watch childList + class attributes across the document.
  enhanceGuideTriggers();
  enhanceKiwiTableHeaders();
  syncKiwiModalFocus();
  new MutationObserver(() => {
    enhanceGuideTriggers();
    // Also on every mutation, not just on open: Kiwi swaps the table out when
    // the shopper switches chart tabs or changes variant, and the replacement
    // arrives as plain <td>s again.
    enhanceKiwiTableHeaders();
    syncKiwiModalFocus();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (state.elements?.fitModal?.classList.contains('active')) {
      showFitModal();
    } else if (document.querySelector('.kiwi-sizing-modal-visible')) {
      document.querySelector('.ks-modal-close')?.click();
    } else if (state.elements?.body?.classList.contains('active')) {
      removeColor();
    }
  });
  state.elements.notifyButton.addEventListener('click', showNotifyModal);
  state.elements.notifyBackdrop.addEventListener('click', showNotifyModal);
  state.elements?.optionBottomBackdrop?.addEventListener('click', removeColor);
  state.elements?.optionColorWrapper?.addEventListener('click', () => showColor(state.elements.optionColorWrapper.dataset.optionsCount));
  state.elements?.optionColorClose?.addEventListener('click', removeColor);
  state.optionGroups.forEach((group) => {
    group.wrapper.addEventListener('change', onOptionChange.bind(group));
  });
  state.elements?.colorsContainer?.addEventListener('click', (e) => {
    // The close button lives in this container too, and onColorChange resets
    // the quantity before it bails on a non-swatch target.
    if (e.target.closest('.pdp__options--item')) onColorChange(e);
    removeColor();
  });
  state.elements?.colorsContainer?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      const swatch = e.target.closest('.pdp__options--item');
      if (swatch) {
        e.preventDefault();
        swatch.click();
      }
    }
  });
  state.elements.addToCart.addEventListener('click', addToCartFunction);
  state.elements.klarnaWrappers.forEach((wrapper) => {
    const KlarnaLoadObserver = new MutationObserver(onKlarnaLoad);
    KlarnaLoadObserver.observe(wrapper, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  });
  DESKTOP_MEDIA.onchange = onDesktopMediaChange;

  if (state.elements.formContainer) {
    new OverflowScroller(state.elements.formContainer);
  }

  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const target = node.querySelector('a.closeShipInsureModal');
            if (target) {
              target.setAttribute('href', '#');
              observer.disconnect();
            }
          }
        });
      } else if (mutation.type === 'attributes') {
        const { target } = mutation;
        if (target.classList.contains('closeShipInsureModal')) {
          target.setAttribute('href', '#');
          observer.disconnect();
        }
      }
    }
  });

  const config = { attributes: true, childList: true, subtree: true };

  const targetNode = document.body;
  observer.observe(targetNode, config);
};

const init = () => {
  const hasProduct = window.product;
  const isAlreadyRun = isScriptFullyLoaded('pdp');

  if (!hasProduct) return;
  if (isAlreadyRun && state.isPDP) {
    markScriptFullyLoaded('pdp');
    return;
  }

  cacheState();
  attachEventListeners();
  onDesktopMediaChange();
  replaceProductDescriptionWord();
};

onDocumentReady(init);

